import { PlanPurchaseExperienceDialog } from '@app/common/src/components/PlanPurchaseExperienceDialog'
import { UpsellModalProps } from './UpsellModalProps'
import React, { forwardRef } from 'react'

/**
 * This is an abstraction of the PlanPurchaseExperience component to be used in-page
 * for upsells.
 *
 * It is currently called a Modal for lack of a better name, but it could be expanded
 * to be a full-page overlay or a series of modals or any desirable experience so long
 * as there's a clear way to initiate the experience (open/start) and to know when the
 * user is done with it (onClose/onFinish).
 *
 * This can be further abstracted into a LimitUpsellModal or LockUpsellModal to differentiate
 * the experience of hitting a limit vs activating a locked feature. More use cases may arise
 * in the future.
 *
 * This modal should NOT be used on its own but only serve as a lower level abstraction for
 * functionality common to all upsell experiences.
 *
 * @see LimitUpsellModal
 */
export const UpsellModal = forwardRef<HTMLDivElement, UpsellModalProps>(function UpsellModal(
  props,
  ref
): JSX.Element {
  return (
    <PlanPurchaseExperienceDialog
      {...props}
      ref={ref}
      onClose={() => props.onClose('dismiss')}
      onSuccessfulCheckout={() => props.onClose('success')}
    />
  )
})
